import React, {useContext, useEffect} from 'react';
import {IntlProvider} from 'react-intl';

import AppLocale from '../../shared/localization';
import AppContext from './AppContext';
import AppContextPropsType from '../../types/AppContextPropsType';
import {IntlGlobalProvider} from './Utils';
import {Language as LanguageKey, Read} from 'utils/localstorage';

const LocaleProvider = (props: any) => {
  const {locale, rtlLocale, changeLocale, setRTL} = useContext<AppContextPropsType>(AppContext);
  const currentAppLocale = AppLocale[locale.locale];

  useEffect(() => {
    const lastCurrentAppLocale = Read(LanguageKey);
    if (lastCurrentAppLocale) {
      if (rtlLocale.indexOf(lastCurrentAppLocale.locale) !== -1) {
        setRTL!(true);
      } else {
        setRTL!(false);
      }
      changeLocale!(lastCurrentAppLocale);
    }
  }, []);

  return (
    <IntlProvider
      onError={console.warn}
      locale={currentAppLocale.locale}
      defaultLocale='fr'
      messages={currentAppLocale.messages}>
      <IntlGlobalProvider>{props.children}</IntlGlobalProvider>
    </IntlProvider>
  );
};

export default LocaleProvider;
